import React from 'react'
import {Link} from 'gatsby'
import {useTranslation} from "gatsby-plugin-react-i18next";

const CEXb = () => {
    const {t} = useTranslation();

    return (
        <section className="featured-services-area pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <h2>{t('home.CEXbh2')}</h2>
                    <p>{t('home.CEXbp')}</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-sm-6">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-analysis"></i>
                            </div>
                            <h3>
                                <Link to="/services">
                                    {t('home.CEXbh31')}
                                </Link>
                            </h3>
                            <p>{t('home.CEXbp2')}
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-structure"></i>
                            </div>
                            <h3>
                                <Link to="/services">
                                    {t('home.CEXbh32')}
                                </Link>
                            </h3>
                            <p>{t('home.CEXbp3')}</p>
                        </div>
                    </div>

                    <div className="col-lg-4 col-sm-6 offset-lg-0 offset-sm-3">
                        <div className="single-featured-services-box">
                            <div className="icon">
                                <i className="flaticon-idea"></i>
                            </div>
                            <h3>
                                <Link to="/services">
                                    {t('home.CEXbh33')}
                                </Link>
                            </h3>
                            <p> {t('home.CEXbp4')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CEXb